import React from 'react';
import { Button, Space } from 'antd';
import {
  PlusOutlined,
  CopyrightOutlined,
  BulbOutlined,
  BankOutlined,
  BarcodeOutlined,
  MoreOutlined,
  UploadOutlined,
  DownloadOutlined,
  TrademarkOutlined,
  GlobalOutlined,
} from '@ant-design/icons';

export interface ServiceType {
  value: string;
  label: string;
  icon: React.ReactNode;
  color?: string;
}

export const SERVICE_TYPES: ServiceType[] = [
  {
    value: 'trademark',
    label: '商标服务',
    icon: <TrademarkOutlined />,
    color: '#1890ff'
  },
  {
    value: 'madrid',
    label: '马德里商标',
    icon: <GlobalOutlined />,
    color: '#fa8c16'
  },
  {
    value: 'patent',
    label: '专利服务',
    icon: <BulbOutlined />,
    color: '#722ed1'
  },
  {
    value: 'copyright',
    label: '版权服务',
    icon: <CopyrightOutlined />,
    color: '#13c2c2'
  },
  {
    value: 'company',
    label: '工商服务',
    icon: <BankOutlined />,
    color: '#52c41a'
  },
  {
    value: 'barcode',
    label: '条形码服务',
    icon: <BarcodeOutlined />,
    color: '#fa541c'
  },
  {
    value: 'other',
    label: '其他服务',
    icon: <MoreOutlined />,
    color: '#8c8c8c'
  }
];

interface ServiceTypeButtonsProps {
  onServiceSelect: (serviceType: string) => void;
  showImportExport?: boolean;
  onImport?: () => void;
  onExport?: () => void;
}

const ServiceTypeButtons: React.FC<ServiceTypeButtonsProps> = ({
  onServiceSelect,
  showImportExport = false,
  onImport,
  onExport
}) => {
  return (
    <Space wrap>
      {SERVICE_TYPES.map((service) => (
        <Button
          key={service.value}
          type="default"
          icon={<PlusOutlined style={{ marginRight: 4 }} />}
          onClick={() => onServiceSelect(service.value)}
          style={{
            borderColor: service.color,
            color: service.color,
          }}
          onMouseEnter={(e) => {
            const target = e.currentTarget;
            target.style.backgroundColor = service.color!;
            target.style.color = 'white';
          }}
          onMouseLeave={(e) => {
            const target = e.currentTarget;
            target.style.backgroundColor = 'transparent';
            target.style.color = service.color!;
          }}
        >
          {service.icon}
          {service.label}
        </Button>
      ))}

      {showImportExport && (
        <>
          <Button
            icon={<UploadOutlined />}
            onClick={onImport}
            style={{ marginLeft: 16 }}
          >
            导入数据
          </Button>
          <Button
            icon={<DownloadOutlined />}
            onClick={onExport}
          >
            导出数据
          </Button>
        </>
      )}
    </Space>
  );
};

export default ServiceTypeButtons;
